<template>
  <div class="navigation_tabs_container mb-4">
    <div class="tabs_wrapper">
      <button 
        v-for="tab in tabs" 
        :key="tab.id"
        class="nav_tab_btn"
        :class="{ 'is-active': activeTab === tab.id }"
        @click="$emit('change', tab.id)"
      >
        <span class="tab_icon" v-html="tab.icon"></span>
        <span class="tab_label">{{ tab.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTabs',
  props: {
    activeTab: {
      type: String,
      default: 'resultados'
    }
  },
  data() {
    return {
      tabs: [
        { 
          id: 'resultados', 
          label: 'Resultados', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line><path d="M7 10l2-2 3 3 5-5"></path></svg>` 
        },
        { 
          id: 'ventas', 
          label: 'Ventas', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 6l-9.5 9.5-5-5L1 18"></path><path d="M17 6h6v6"></path></svg>` 
        },
        { 
          id: 'costos', 
          label: 'Costos', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 18l-9.5-9.5-5 5L1 6"></path><path d="M17 18h6v-6"></path></svg>` 
        },
        { 
          id: 'gastos', 
          label: 'Gastos', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 18l-9.5-9.5-5 5L1 6"></path><path d="M17 18h6v-6"></path></svg>` 
        },
        { 
          id: 'rentabilidad', 
          label: 'Rentabilidad', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>` 
        },
        { 
          id: 'no_oper', 
          label: 'No Oper', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>` 
        },
        { 
          id: 'activos', 
          label: 'Activos', 
          icon: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>` 
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.navigation_tabs_container {
  display: flex;
  width: 100%;
}

.tabs_wrapper {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.nav_tab_btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #e1e4e8;
  background: white;
  color: #4a5568;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 38px;

  &:hover {
    background-color: #f7fafc;
    border-color: #cbd5e0;
  }

  &.is-active {
    background-color: #0d3c3f;
    border-color: #0d3c3f;
    color: white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .tab_icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
